import { render, staticRenderFns } from "./UsersHistoryModal.vue?vue&type=template&id=7ba1311e"
import script from "./UsersHistoryModal.vue?vue&type=script&lang=js"
export * from "./UsersHistoryModal.vue?vue&type=script&lang=js"
import style0 from "@/assets/usersHistory.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/LAcordion.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports